import { appSelectors } from '@appStore/reducers/app'
import { useAutomationLinkedInStatus } from 'features/linked-in-status'
import { useAppSelector } from 'shared/hooks'

export const useSubscriptionActive = () =>
	useAppSelector(state => appSelectors.persona(state)?.subscriptionIsActive)

export function useIsAvailable() {
	const isSubscriptionActive = useSubscriptionActive()
	const { autoMode, isSignedIn, isSuccess } = useAutomationLinkedInStatus()
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	const isOpsSession = useAppSelector(appSelectors.appProfile)?.isOpsSession

	const isGeneralActive = Boolean(isSubscriptionActive && isSignedIn)
	const isCorrectAutoMode =
		isSuccess &&
		autoMode?.is_proxy_available === true &&
		isSignedIn

	const result =
		isGeneralActive &&
		((!isImpersonated || isCorrectAutoMode) ||
			(Boolean(isOpsSession) && isCorrectAutoMode))
	return result
}
